module.exports = __webpack_public_path__ + "static/media/CaptureReneDaniel.9d5a9d43.JPG";